const isLeapYear = (year: number) => new Date(year, 1, 29).getMonth() === 1;

export const daysInYear = (year: number) => isLeapYear(year) ? 366 : 365;
